<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { inject } from 'vue'
import { PovinnaPrilohaPublicResponsePozadovanaOriginalitaDokumentovEnum } from '/@src/client-public'
import { richTextToGovukHtml } from '/@src/utils/richTextToGovukHtml'

const { t } = useI18n()
const specResponse = inject('specResponse')

const getOriginalitaDokumentovLocalized = (originalita: string | undefined) => {
  switch (originalita) {
    case PovinnaPrilohaPublicResponsePozadovanaOriginalitaDokumentovEnum.Original:
      return t('Original')
    case PovinnaPrilohaPublicResponsePozadovanaOriginalitaDokumentovEnum.Kopia:
      return t('Kopia')
    case PovinnaPrilohaPublicResponsePozadovanaOriginalitaDokumentovEnum.UradneOsvedcenaKopia:
      return t('UradneOsvedcenaKopia')
    default:
      return originalita
  }
}
</script>

<template>
  <table class="govuk-table">
    <thead class="govuk-table__head">
      <tr class="govuk-table__row">
        <th scope="col" class="govuk-table__header">
          {{ t('zoppm.step0.prilohyTable.nazov') }}
        </th>
        <th scope="col" class="govuk-table__header">
          {{ t('zoppm.step0.prilohyTable.sposobPredlozeniaTitle') }}
        </th>
        <th scope="col" class="govuk-table__header">
          {{ t('zoppm.step0.prilohyTable.stiahnutie') }}
        </th>
      </tr>
    </thead>
    <tbody class="govuk-table__body">
      <tr
        v-for="priloha of specResponse.zoppmSpec.povinnePrilohy"
        :key="priloha.povinnaPrilohaRef.zoppmSpecId"
        class="govuk-table__row"
      >
        <td class="govuk-table__cell">
          <b>{{ priloha.povinnaPrilohaRef.nazov }}</b>
          <p v-html="richTextToGovukHtml(priloha.popis)" />
        </td>
        <td class="govuk-table__cell">
          {{
            t('zoppm.step0.prilohyTable.sposobPredlozenia.' + priloha.sposobPredlozenia)
          }}
        </td>
        <td class="govuk-table__cell muted">
          {{ t('zoppm.step0.prilohyTable.uvedeneVoVyzve') }}
        </td>
      </tr>
    </tbody>
  </table>
</template>


<style lang="scss">
.muted {
  color: var(--idsk-color-dark-grey);
}
td {
  white-space: pre-line;
}
</style>

<i18n lang="yaml">
sk:
  Original: 'originál'
  Kopia: 'kópia'
  UradneOsvedcenaKopia: 'úradne osvedčená kópia'
</i18n>
